import React from 'react';
import PropTypes from 'prop-types';

import pick from 'lodash/pick';
import isEmpty from 'lodash/isEmpty';
import findKey from 'lodash/findKey';

import { optimiseImage } from 'src/common/utils/prismic-image';
import { getBreakpointQuery } from 'src/common/config/breakpoints';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';

import './ResponsiveImage.scss';

const getImageSrc = image => optimiseImage(image.url, { auto: 'format,compress', w: image.dimensions.width });

// prettier-ignore
const renderResponsiveSources = responsiveImages =>
  !isEmpty(responsiveImages) &&
  Object.keys(responsiveImages)
    .map(key => (
      <source
        key={key}
        media={getBreakpointQuery(key)}
        srcSet={getImageSrc(responsiveImages[key])}
        sizes={`${responsiveImages[key].dimensions.width / 2}px`}
      />
    ));

const setImageWidth = props => {
  const { media, images } = props;
  const responsiveImages = pick(images, ['mobile', 'fablet', 'tablet']);
  const responsiveKeys = Object.keys(responsiveImages);
  const activeMedia = findKey(media, (value, key) => responsiveKeys.includes(key) && media[key]);

  if (activeMedia) {
    return `${responsiveImages[activeMedia].dimensions.width / 2}px`;
  }

  return `${images.dimensions.width / 2}px`;
};

const ResponsiveImage = props => (
  <picture className="responsive-image">
    {renderResponsiveSources(pick(props.images, ['mobile', 'fablet', 'tablet']))}
    <img
      src={getImageSrc(props.images)}
      alt={props.images.alt || props.alt || ''}
      className={props.className}
      width={setImageWidth(props)}
    />
  </picture>
);

ResponsiveImage.propTypes = {
  images: PropTypes.shape({
    url: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }).isRequired,
    copyright: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  alt: PropTypes.string
};

export default withMedia(ResponsiveImage);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ResponsiveImage/ResponsiveImage.js